import type { JSX } from "react";

import { Tooltip } from "@similarweb/ui-components";

import Button from "app/components/React/Button/Button";
import { AssetsService } from "app/services/AssetsService";
import I18n, { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { CloseIconButton, DescriptionWrapper, TitleWrapper, Wrapper } from "./EngagementExcelDownloadPopup.styles";

interface IEngagementExcelDownloadPopupProps {
    onCloseClick: () => void;
    onCtaClick: () => void;
}

export const EngagementExcelDownloadPopup = ({
    onCloseClick,
    onCtaClick,
}: IEngagementExcelDownloadPopupProps): JSX.Element => {
    const translate = useTranslation();

    return (
        <Wrapper>
            <Tooltip content={translate("download.excel.engagement.popup.closeTooltipContent")}>
                <CloseIconButton
                    type="flat"
                    onClick={onCloseClick}
                    iconName="clear"
                    placement="left"
                    iconSize="xs"
                />
            </Tooltip>

            <img
                src={AssetsService.assetUrl("/images/megaphone.gif")}
                width="72px"
                height="72px"
                alt="speaker"
            />

            <TitleWrapper>
                <I18n>download.excel.engagement.popup.title</I18n>
            </TitleWrapper>

            <DescriptionWrapper>
                <I18n>download.excel.engagement.popup.description</I18n>
            </DescriptionWrapper>

            <Button
                style={{ width: "100%" }}
                label={translate("download.excel.engagement.popup.ctaButton")}
                onClick={onCtaClick}
            />
        </Wrapper>
    );
};
